import { useState } from "react";
import { Outlet } from "react-router-dom";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { PodcasterSidebar } from "./PodcasterSidebar";
import { PodcasterHeader } from "./PodcasterHeader";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { SessionTimeoutWarning } from "@/components/auth/SessionTimeoutWarning";
import { ImpersonationBanner } from "@/components/layout/ImpersonationBanner";
import { useActivityTimeout } from "@/hooks/useActivityTimeout";
import { useAuth } from "@/contexts/AuthContext";

export function PodcasterLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { signOut, isAuthenticated, isImpersonating } = useAuth();
  
  // Check if user selected "Remember me"
  const isRemembered = localStorage.getItem('podgo_remember_me') === 'true';
  
  const { showWarning, timeRemaining, extendSession } = useActivityTimeout({
    timeoutMinutes: isRemembered ? 10080 : 240, // 7 days or 4 hours
    warningMinutes: 5,
    onTimeout: () => signOut(),
    enabled: isAuthenticated,
  });

  return (
    <div className="flex flex-col min-h-screen bg-background overflow-x-hidden">
      {/* Impersonation Banner */}
      {isImpersonating && <ImpersonationBanner />}

      {/* Full-width Header - TooLost style */}
      <PodcasterHeader onMenuClick={() => setSidebarOpen(true)} />

      {/* Content area with sidebar */}
      <div className="flex flex-1">
        {/* Desktop Sidebar - visible at 1200px+ (md breakpoint) */}
        <aside className="hidden md:flex md:w-64 md:flex-col md:flex-shrink-0">
          <PodcasterSidebar />
        </aside>

        {/* Mobile/Tablet Sidebar Drawer - visible below 1200px */}
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetContent side="left" className="p-0 w-64 sm:w-72">
            <PodcasterSidebar 
              onNavigate={() => setSidebarOpen(false)}
              showCloseButton={true}
              onClose={() => setSidebarOpen(false)}
            />
          </SheetContent>
        </Sheet>

        {/* Main Content */}
        <div className="flex-1 min-w-0">
          <main className="p-4 sm:p-6 md:p-8 overflow-hidden">
            <div className="max-w-7xl mx-auto min-w-0">
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      {/* Footer */}
      <MarketingFooter />

      {/* Session Timeout Warning Modal */}
      <SessionTimeoutWarning
        open={showWarning}
        timeRemaining={timeRemaining}
        onExtend={extendSession}
        onLogout={signOut}
      />
    </div>
  );
}
